import React from 'react'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'

const Overlay = ({ text, children, isRounded }) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        zIndex: theme.zIndex.overlay,
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        opacity: 0.92,
        borderRadius: 3,
        backgroundColor: theme.palette.background.darkBlue,
      }}
    >
      {children}
    </Box>
  )
}

export default Overlay
